import { Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import VerticalSpacerNodeView from './VerticalSpacerNodeView.vue';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        verticalSpacer: {
            /** Insert a vertical spacer at the current position. */
            insertVerticalSpacer: (height?: number) => ReturnType;
        };
    }
}

export const VerticalSpacerExtension = Node.create({
    name: 'verticalSpacer',

    group: 'block',
    atom: true,
    selectable: true,
    draggable: true,

    addAttributes() {
        return {
            height: {
                default: 2,
                parseHTML: (element) =>
                    parseInt(element.getAttribute('data-height') ?? '2', 10),
                renderHTML: (attributes) => ({
                    'data-height': attributes.height,
                    style: `height: ${attributes.height}rem`,
                }),
            },
        };
    },

    parseHTML() {
        return [{ tag: 'div[data-vertical-spacer]' }];
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', { 'data-vertical-spacer': '', ...HTMLAttributes }];
    },

    addNodeView() {
        return VueNodeViewRenderer(VerticalSpacerNodeView);
    },

    addCommands() {
        return {
            insertVerticalSpacer:
                (height = 2) =>
                ({ chain }) => {
                    return chain()
                        .focus()
                        .insertContent({
                            type: 'verticalSpacer',
                            attrs: { height },
                        })
                        .run();
                },
        };
    },
});
